import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { LanguageService } from '../../../../../core/services/language.service';
import { Subscription } from 'rxjs';
import { Providers } from '../../../../../core/models/information.model';
import { ApiProviderService } from '../../../../../core/services/api/Parking/api-provider';
import { PssLoadingComponent } from '../../../../../tools/template/pss/pss-loading/pss-loading.component';

@Component({
  selector: 'app-service-providers-2',
  imports: [
    CommonModule,
    FormsModule,
    PssLoadingComponent,
  ],
  templateUrl: './service-providers-2.component.html',
  styleUrl: './service-providers-2.component.css'
})
export class ServiceProviders2Component implements OnInit, OnDestroy {
  /* -------------------------------------------- Variable -------------------------------------------- */
  sub: Subscription;
  currentLang: string = '';

  uid: string = '';
  token: string = '';
  isLoading: boolean = false; // สถานะการโหลดข้อมูล
  searchTerm: string = ''; // คำค้นหา Provider
  providersDetails: Providers[] = [];

  ProvidersOptions: {
    id: number;
    name: string;
    address: string;
    logo_base64: string;
  }[] = [];
  filteredProviders: {
    id: number;
    name: string;
    address: string;
    logo_base64: string;
  }[] | null = null;

  image: string = '';
  searchParking: string = '';

  constructor(
    private cookieService: CookieService,
    private apiProviderService: ApiProviderService,
    private router: Router,
    private languageService: LanguageService
  ) {
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
  }

  ngOnInit(): void {
    this.uid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
    // JWT is HttpOnly cookie — token_user no longer used
    this.token = '';
    setTimeout(() => {
      this.requestGetProviders();
    }, 300);
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  // ================= Normal Functions =================

  /**
   * Navigate to the home page.
   */
  goHome() {
    this.router.navigate(['/home']);
  }

  /**
   * Store provider information in sessionStorage and navigate to the member vehicle registration page.
   * @param providerId The ID of the provider.
   * @param providerName The name of the provider.
   */
  openProvider(providerId: number, providerName: string) {
    console.log("Provider ID : ", providerId);
    console.log("Provider Name : ", providerName);
    setTimeout(() => {
      sessionStorage.setItem('providerId', providerId.toString());
      sessionStorage.setItem('providerName', providerName);
      this.router.navigate(['/register-member-vehicle'], {
        state: { providerId: providerId },
      });
    }, 0);
  }

  /**
   * Navigate back to the home page.
   */
  goback() {
    this.router.navigate(['/home']);
  }

  /**
   * Filter the list of providers based on the search query input by the user.
   */
  onSearchLocation() {
    if (this.searchParking === '') {
      this.filteredProviders = null;
      return;
    }

    const term = this.searchParking.toLowerCase();
    this.filteredProviders = this.ProvidersOptions.filter((provider) =>
      provider.name.toLowerCase().includes(term) ||
      (provider.address && provider.address.toLowerCase().includes(term))
    );
    console.log("Search location : ", this.filteredProviders);
  }

  /**
   * Clear the search input and reset the filtered provider list.
   */
  onClearSearch() {
    this.searchParking = '';
    this.filteredProviders = null;
    console.log('clear search', this.searchParking);
  }

  // ================= API Functions =================

  /**
   * Fetch the list of providers from the API and map their details, ensuring the base64 logos are formatted properly.
   */
  requestGetProviders() {
    this.isLoading = true;
    this.apiProviderService.getProviders().subscribe({
      next: (response: Providers[]) => {
        console.log("Response Get Provider : ", response)
        this.isLoading = false;
        const providers = Array.isArray(response)
          ? response
          : [];

        this.providersDetails = providers;

        this.ProvidersOptions = providers.map(
          (provider: Providers) => {
            let logo = provider.logo_base64 || '';
            // If the base64 image data does not start with standard data url prefix, add it.
            if (logo && !logo.startsWith('data:')) {
              logo = `data:image/png;base64,${logo}`;
            }
            return {
              id: provider.id,
              name: provider.name,
              address: provider.address,
              logo_base64: logo,
            };
          }
        );
      },
      error: (error) => {
        console.error('API error:', error);
        this.isLoading = false;
      },
    });
  }
}
